import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const uniq = <T = string | number>(array: Array<T>): Array<T> => {
  return Array.from(new Set(array));
};

export const jsonParse = (clause: string) => {
  const splitStingArr = clause.split(/(\{|\})/);

  let returnStr = '';

  let insidePar = false;

  splitStingArr.forEach(s => {
    if (s === '{') {
      insidePar = true;
      returnStr += s;
      return;
    }
    if (s === '}') {
      insidePar = false;
      returnStr += s;
      return;
    }
    if (s === ',' && insidePar) {
      returnStr += s;
      return;
    }
    returnStr += s;
  });

  return returnStr;
};

export const omit = <T = { [key: string]: any }, K extends string = string>(
  omittedFields: Array<K>,
  object: T,
): Omit<T, K> => {
  if (!object) return {} as Omit<T, K>;
  if (omittedFields.length < 1) return object;

  const omittedFieldsSet = new Set(omittedFields);
  return Object.fromEntries(Object.entries(object).filter(e => !omittedFieldsSet.has(e[0] as K))) as Omit<T, K>;
};

export const tryParseJSONObject = (jsonString: any) => {
  try {
    const o = JSON.parse(jsonString);

    // Handle non-exception-throwing cases:
    // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
    // but... JSON.parse(null) returns null, and typeof null === "object",
    // so we must check for that, too. Thankfully, null is falsey, so this suffices:
    if (o && typeof o === 'object') {
      return o;
    }
  } catch (e) {}

  return false;
};
